module.exports = "https://web-assets.ifttt.com/packs/media/onboarding/selector_helper@2x-9a442ef7.png";